// extracted by mini-css-extract-plugin
export default {"brand":"brand_button-module__brand--2veZL","small":"brand_button-module__small--vJwCl","large":"brand_button-module__large--2mo0o","expanded":"brand_button-module__expanded--3VAFD"};